// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import PrescriptionsView from "../../components/prescriptions";

const PrescriptionsClinic = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <PrescriptionsView software="clinic" />
    </Main>
  </>
);

export default PrescriptionsClinic;
